import React, { useEffect } from 'react';
import Header from './Components/Header';
import Footer from './Components/Footer';
import { RouterProvider, useLocation } from 'react-router-dom'; // Import RouterProvider
import Index from './Routes';
import { I18nextProvider } from 'react-i18next';
import i18n from './Components/i18n'; // Import your i18n configuration
import "./App.css"
// Import Material-UI's ThemeProvider and CssBaseline
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './Components/theme'; // Import the custom theme
import { storage } from './Config/Storage';

const App = () => {
  const location = useLocation();
  useEffect(() => {
    // Add a listener to clear storage when the page is refreshed
    const handleBeforeUnload = () => {
      // Clear local storage and session storage
      storage.destory.chathistory();
    };

    // Add event listener
    window.addEventListener("beforeunload", handleBeforeUnload);

    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
  return (

    <I18nextProvider i18n={i18n}>
      {/* Wrap the entire app with ThemeProvider for global theming */}
      <ThemeProvider theme={theme}>
        <CssBaseline /> {/* CssBaseline provides a consistent styling baseline */}
        <Header />
        <Index /> {/* Handles your routes */}
        <Footer />
      </ThemeProvider>
    </I18nextProvider>
  )
}

export default App;
